import React from 'react';

import "./Gdpr.scss";

import { Article } from "../../../elements/Article/Article";
import { Link } from '@randajan/jet-react/dom/link';

export const Gdpr = (props)=>{
    const {} = props;
    
    return (
        <Article className="Gdpr wall block" src="/langs/docs/gdpr.md" local/>
    )
}



export const LinkGdpr = (props)=>{
    return (
        <p>Odesláním souhlasíte se <Link to="/docs/gdpr">zpracováním osobních údajů</Link></p>
    )
}